export default __webpack_public_path__ + "static/media/calendar.8dc8f8e5.svg";